function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import axios from 'axios';
import { environment } from './environment';
import { airbrake, skipRequestErrorTracking } from './airbrake';

// Define an enum for environments
var Environment = {
  DOCKER: 'docker',
  STAGING: 'staging',
  DEVELOPMENT: 'development',
  PRODUCTION: 'production',
  TEST: 'test'
};
var checkChinaUsers = function checkChinaUsers() {
  if (typeof window !== 'undefined') {
    var currentUrl = window.location.href;
    return currentUrl.includes('china');
  }
  return false;
};
var getApiBaseUrl = function getApiBaseUrl() {
  var env = environment(); // Get the environment
  var isChinaUser = checkChinaUsers(); // Determine if China user based on URL
  var baseUrl;
  switch (env) {
    case Environment.DOCKER:
      baseUrl = isChinaUser ? 'https://megatron-aje-china.local.sqr.io' : 'https://megatron-aje.local.sqr.io';
      break;
    case Environment.STAGING:
    case Environment.DEVELOPMENT:
      baseUrl = isChinaUser ? 'https://secure-aje-china.staging.sqr.io' : 'https://secure-aje.staging.sqr.io';
      break;
    case Environment.TEST:
      baseUrl = isChinaUser ? 'https://secure-aje-china.test.sqr.io' : 'https://secure-aje.test.sqr.io';
      break;
    default:
      baseUrl = isChinaUser ? 'https://china.aje.com' : 'https://secure.aje.com';
  }
  return baseUrl;
};
var defaults = {
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'x-xhr-request': true
  },
  withCredentials: true,
  validateStatus: function validateStatus(status) {
    return status < 500 && status !== 401;
  },
  // This is set to match nginx keepalive_timeout
  timeout: 60 * 1000
};
var fetchRequest = function fetchRequest(requestPromise, params) {
  return new Promise(function (resolve, reject) {
    return requestPromise.then(function (response) {
      return resolve(response.data || {});
    }).catch(function (error) {
      var response = error.response || {};
      if (!skipRequestErrorTracking(error)) {
        airbrake === null || airbrake === void 0 || airbrake.notify({
          error: error,
          params: _objectSpread(_objectSpread({}, params), {}, {
            response: response
          })
        });
      }

      // Rethrow the error so we don't fall through to .then
      return reject(error);
    });
  });
};
var req = function req(options) {
  // Transform URL here once, before creating the payload
  if (options.url && !options.url.startsWith('http')) {
    options.url = "".concat(getApiBaseUrl()).concat(options.url.startsWith('/') ? options.url : "/".concat(options.url));
  }
  var payload = _objectSpread(_objectSpread({}, defaults), options);
  if (payload.data instanceof FormData) {
    payload.headers['Content-Type'] = undefined;
  }
  return fetchRequest(axios.request(payload), options);
};
var get = function get(url) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return req(_objectSpread({
    url: url,
    params: params,
    method: 'get'
  }, options));
};
var del = function del(url) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return req(_objectSpread({
    url: url,
    params: params,
    method: 'delete'
  }, options));
};
var put = function put(url) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return req(_objectSpread({
    url: url,
    data: data,
    method: 'put'
  }, options));
};
var post = function post(url) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return req(_objectSpread({
    url: url,
    data: data,
    method: 'post'
  }, options));
};
export { getApiBaseUrl, checkChinaUsers };
var request = {
  del: del,
  get: get,
  post: post,
  put: put,
  req: req
};
export default request;